'use strict';

if (!require('./is-implemented')()) {
	Object.defineProperty(require('es5-ext/global'), 'Map',
		{ value: require('./polyfill'), configurable: true, enumerable: false,
			writable: true });
}



//////////////////
// WEBPACK FOOTER
// ./~/es6-map/implement.js
// module id = 2562
// module chunks = 0